import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Sparkles, FolderOpen, Wand2 } from 'lucide-react';
import { SiteHeader } from '../components/layout/SiteHeader';
import { Button } from '../components/ui/Button';
import { Spinner } from '../components/ui/Spinner';
import { useProjectStore } from '../state/projectStore';
import { useUiStore } from '../state/uiStore';
import { createDemoProject } from '../demo/createDemoProject';
import { t } from '../i18n';
import './intro-page.css';

export default function IntroPage() {
  const navigate = useNavigate();
  const hydrateNewProject = useProjectStore((s) => s.hydrateNewProject);
  const pushToast = useUiStore((s) => s.pushToast);
  const [loadingDemo, setLoadingDemo] = useState(false);

  const handleLoadDemo = async () => {
    setLoadingDemo(true);
    try {
      const { project, assetsRuntime } = await createDemoProject();
      await hydrateNewProject(project, assetsRuntime);
      navigate(`/editor/${project.id}`);
    } catch (err) {
      pushToast({
        kind: 'error',
        message: err instanceof Error ? err.message : t('common.unknownError'),
      });
      setLoadingDemo(false);
    }
  };

  return (
    <div className="page-shell">
      <SiteHeader />
      <div className="intro-hero">
        <div className="intro-hero-content">
          <h1>{t('intro.title')}</h1>
          <p className="intro-subtitle">{t('intro.subtitle')}</p>
          <div className="intro-actions">
            <Button asChild variant="primary" size="lg">
              <Link to="/nieuw">
                <Sparkles size={18} />
                {t('intro.newProject')}
              </Link>
            </Button>
            <Button asChild variant="secondary" size="lg">
              <Link to="/projecten">
                <FolderOpen size={18} />
                {t('intro.openProject')}
              </Link>
            </Button>
            <Button variant="ghost" size="lg" onClick={handleLoadDemo} disabled={loadingDemo}>
              {loadingDemo ? <Spinner size={18} /> : <Wand2 size={18} />}
              {t('intro.loadDemo')}
            </Button>
          </div>
          <p className="intro-guest-note">{t('intro.continueAsGuest')}</p>
          <p className="intro-login-cta">
            <Link to="/login">{t('intro.loginCta')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
